import api from '../config/api';

export const reservationService = {
  createReservation: async (reservationData) => {
    const response = await api.post('/reservations', reservationData);
    return response.data;
  },

  getAllReservations: async (status) => {
    const response = await api.get('/reservations/admin/all', {
      params: { status }
    });
    return response.data;
  },

  getMemberReservations: async (memberId) => {
    const response = await api.get(`/reservations/member/${memberId}`);
    return response.data;
  },

  approveReservation: async (id) => {
    const response = await api.put(`/reservations/${id}/approve`);
    return response.data;
  },

  rejectReservation: async (id, reason) => {
    const response = await api.put(`/reservations/${id}/reject`, { reason });
    return response.data;
  },

  moveReservation: async (id, newClassId) => {
    const response = await api.put(`/reservations/${id}/move`, { newClassId });
    return response.data;
  },

  cancelReservation: async (id) => {
    const response = await api.delete(`/reservations/${id}`);
    return response.data;
  },

  // Get all reservations with details (optimized for admin)
  getAllReservationsWithDetails: async () => {
    const response = await api.get('/reservations/admin/all-with-details');
    return response.data;
  },

  // Get cancelled reservations with details (admin only)
  getCancelledReservationsWithDetails: async () => {
    const response = await api.get('/reservations/admin/cancelled-with-details');
    return response.data;
  }
};

